import Default from '@fiverr-private/footer/entries/Default';

export default Default;
